import { usePolling } from "@roman/shared/hooks/usePolling";
import { useAuthStore } from "@roman/shared/store/auth.store";
import { minutesToMilliseconds } from "date-fns";
import { useEffect } from "react";
import { useShallow } from "zustand/shallow";

// every 10 minutes refresh the token
const POLLING_INTERVAL = minutesToMilliseconds(10);

/// poll refresh token and set the local storage
export const usePollRefreshToken = (onSuccess?: () => void, onFailure?: () => void) => {
  const refreshToken = useAuthStore(useShallow((state) => state.refreshToken));
  const { startPolling, stopPolling } = usePolling({
    interval: POLLING_INTERVAL,
  });

  useEffect(() => {
    startPolling(async () => {
      await refreshToken(onSuccess, onFailure);
    });

    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling, refreshToken, onSuccess, onFailure]);
};

export default usePollRefreshToken;
